import { ImageLoader, ImageProps } from "next/image";

import { transformImageUrl } from "services/content-manager/images";

const CMS_ASSET_HOSTNAME_REGEX = /.kc-usercontent.com$|.kenticocloud.com$/;

export const srcIsCmsAsset = (src: ImageProps["src"]) => {
    try {
        if (typeof src === "string") {
            const { hostname } = new URL(src);
            const srcIsCmsAsset = CMS_ASSET_HOSTNAME_REGEX.test(hostname);
            return srcIsCmsAsset;
        } else {
            return false;
        }
    } catch {
        return false;
    }
};

const cmsImageLoader: ImageLoader = ({ src, width, quality = 100 }) => {
    if (!srcIsCmsAsset(src)) return src;

    return transformImageUrl(src)
        .withWidth(width)
        .withQuality(quality)
        .withAutomaticFormat()
        .getUrl();
};

export default cmsImageLoader;
